import {
  FloatingFormItem,
  InputDate,
  InputDecimal,
  InputText,
  PlanAccountsSelect,
} from '@/components/_common';
import CostCenterInfiniteSelectField from '@/components/_common/CostCenterInfiniteSelectField';
import {
  PlanAccountDestination,
  PlanAccountHierarchy,
} from '@/core/domain/enterprise/PlanAccounts/PlanAccounts.types';
import { AccountPayableGenerateGroupingFormValues } from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, FormInstance, InputNumber, Row } from 'antd';

import React from 'react';

interface Props {
  form: FormInstance<AccountPayableGenerateGroupingFormValues>;
}

const GenerateGroupingForm: React.FC<Props> = ({ form }) => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();
  return (
    <Form form={form}>
      <Row gutter={[24, 24]}>
        <Col span={24} sm={12} md={8} lg={6}>
          <FloatingFormItem name="totalValue" label="Valor total">
            <InputDecimal disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12} md={8} lg={6}>
          <FloatingFormItem
            name="planAccountId"
            label="Plano de contas"
            rules={[defaultEmptyFieldError]}
          >
            <PlanAccountsSelect
              queryFilter={{
                hierarchy: PlanAccountHierarchy.Analitical,
                destination: PlanAccountDestination.Expense,
                active: true,
              }}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12} md={8} lg={6}>
          <FloatingFormItem name="costCenterId" label="Centro de custo">
            <CostCenterInfiniteSelectField
              queryFilter={{
                active: true,
              }}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12} md={8} lg={6}>
          <FloatingFormItem
            name="installmentsFirstDueDate"
            label="Venc. 1º parcela"
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12} md={8} lg={3}>
          <FloatingFormItem
            name="quantityInstallments"
            label="Qtde. parcelas"
            initialValue={1}
          >
            <InputNumber min={1} style={{ width: '100%' }} />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12} md={8} lg={3}>
          <FloatingFormItem
            name="intervalDays"
            label="Intervalo(dias)"
            initialValue={30}
          >
            <InputText onlyNumber />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default GenerateGroupingForm;
